import React, { useEffect } from "react";
import useActivityLoggerStore from "./store";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CardDiv from "modules/common/card-div/CardDiv";

function ActivityLoggerHeader() {
  const {
    slotData,
    slotRescheduleData,
    fourNineBooking,
    fourNineBookingReschedule,
    fetchSlotData,
    fetchSlotResData,
    fetchFourNineData,
    fetchFourNineResData,
  } = useActivityLoggerStore();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const start = searchParams.get("sd");
  const end = searchParams.get("ed");

  const cardDetails = (obj) => {
    return (
      <div>
        <ul className="m-n2">
          <li>
            Call Count:{" "}
           <span className="fw-bold ms-1"> {(obj?.sessionCompleted +
              obj?.sessionNotCompleted)||"0"}</span>
          </li>
          <li>Session Completed Count: <span className="fw-bold ms-1">{obj?.sessionCompleted || "0"} </span></li>
          <li>
            Session Not Completed Count:<span className="fw-bold ms-1"> {obj?.sessionNotCompleted ||"0"}</span>
          </li>
          <li>Booking Success Count:<span className="fw-bold ms-1"> {obj?.bookedSessions || "0"} </span></li>
          <li>Booking Failed Count:<span className="fw-bold ms-1"> {obj?.notBookedSessions || "0"}</span> </li>
          <li>Empty Slots Count:<span className="fw-bold ms-1"> {obj?.emptySlotsResponse ||"0"} </span></li>
        </ul>
      </div>
    );
  };
  useEffect(() => {
    const trimmedStart = start.trim();
    const trimmedEnd = end.trim();
    let startDate = new Date(trimmedStart).getTime();
    let endDate = new Date(trimmedEnd).getTime();
    fetchSlotData(startDate, endDate);
    fetchSlotResData(startDate, endDate);
    fetchFourNineData(startDate, endDate);
    fetchFourNineResData(startDate, endDate);
  }, [start, end]);


  return (
    <div className="d-flex gap-3">
      <div className="flex-1">
        <CardDiv title={"Slot Booking"} component={cardDetails(slotData.SLOT_BOOKING)} />
      </div>
      <div className="flex-1">
        <CardDiv title={"Reschedules Slot Booking"} component={cardDetails(slotRescheduleData.RESCHEDULE_SLOT_BOOKING)} />
      </div>
      <div className="flex-1">
        <CardDiv title={"499 Call"} component={cardDetails(fourNineBooking["499_BOOKING"])} />
      </div>
      <div className="flex-1">
        <CardDiv title={"Rescheduled 499 Call"} component={cardDetails(fourNineBookingReschedule["499_BOOKING_RESHCEDULE"])} />
      </div>
    </div>
  );
}

export default ActivityLoggerHeader;
